const attendanceRoutes = [{
  path: "/Attendance",
  name: "Attendance",
  component: require("@/components/Attendance/Attendance").default
}];

export default attendanceRoutes;